import type { FactoryProductInfoType, GetPreinvoiceResponseType } from "@/services/store/store.types";
import { defineStore } from "pinia";

export const useGlobalStore = defineStore("globalStore", {
  state: () => {
    return {
      updateCardList: false,
      updateAddressList: false,
      updateTransactionList: false,
      newAddressId: undefined,
      updateCustomerList: false,
      newCustomerId: undefined,
      orderNewData: {},
      factoryProductInfo: {} as FactoryProductInfoType,
      preInvoiceData: {} as GetPreinvoiceResponseType | undefined,
    };
  },
});
